import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom"
import _ from "lodash";
import moment from 'moment';

import { getMessage } from "CONFIG/i18n";

// Component
import  toastr  from 'COMPONENTS/ShowTostr/ShowTostr';
import HeaderContainer from "../Header/HeaderContainer";
import SupportCenter from "./SupportCenter";

// Selector
import { getCustomerId } from "../../MainLayout/selectors";
import { getCustomerName } from "REDUX/Selector/OrganisationSelector.js"

// Utilities
import { CONFIG } from "UTILS/Constants";

// Actions
import { userAction, sessionActions } from "CONFIG/ActionFactory";

class SupportCenterContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      operatorList: [],
      waitingSessionList: {
        sessions: [],
        total: 0
      },
      abandonedSessionList: {
        sessions: [],
        total: 0
      },
      todaySessionCountList: {
        waiting: 0,
        abandoned: 0,
        all: 0,
      }
    };
  }

  /** back button */
  handleCancelClick = () => {
    this.props.history.push(CONFIG.path.admin);
  };

  getAllOperators = () => {
    userAction.getAllOperatorsAction(this.props.customerId).then(
      (response) => {
        this.setState({
          operatorList: response.data.data.operators,
        });
      },
      (error) => {
        toastr.error(getMessage(error.code));
      }
    );
  };

  getSupportCenterSessions = () => {
    const startOfToday = moment().startOf("day").toISOString();
    Promise.all([
      sessionActions.getSupportCenterSessionsActions(startOfToday, undefined, undefined, "WAITING"),
      sessionActions.getSupportCenterSessionsActions(startOfToday, undefined, undefined, "ABANDONED"),
      // Get the number of all sessions for today.
      sessionActions.getSupportCenterSessionsActions(startOfToday, 0, 0),
    ]).then((responses) => {
      this.setState({
        waitingSessionList: responses[0].data.data,
        abandonedSessionList: responses[1].data.data,
        todaySessionCountList: {
          waiting: responses[0].data.data.total,
          abandoned: responses[1].data.data.total,
          all: responses[2].data.data.total,
        }
      })
    }).catch((error) => {
      toastr.error(getMessage(error.code));
    });    
  };

  render() {
    return (
      <>

        <HeaderContainer
          title={this.props.organisationName}
          headerButtonText={getMessage("ADD_USER")}
          history={this.props.history}
          showAddUserModal={this.props.showAddUserModal}
          showAddUserDropdown={this.props.showAddUserDropdown}
          showAboutOrgModal={this.props.showAboutOrgModal}
          getAllUserData={this.props.getAllUserData}
          logoUrl={this.props.logoUrl}
          showQRPopUp={this.props.showQRPopUp}
          showQR={this.props.showQR}
          isDashboard={true}
        />

        <SupportCenter
          backToMenu={this.handleCancelClick}
          getAllOperators={this.getAllOperators}
          getSupportCenterSessions={this.getSupportCenterSessions}
          operatorList={this.state.operatorList}
          todaySessionCountList={this.state.todaySessionCountList}
          waitingSessionList={this.state.waitingSessionList}
          abandonedSessionList={this.state.abandonedSessionList}
        />
      </>
    )
  }
}

const mapStateToProps = state => {
  return {
    customerId: getCustomerId(state),
    organisationName: getCustomerName(state),
  };
};
export default withRouter(connect(
  mapStateToProps,
)(SupportCenterContainer));
